<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QmiCvt/tc-custom/9780814758472.jpg?1719927332355" alt="This image is the cover for the book Helen Keller, History of Disability"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Helen Keller, History of Disability
      </h1>
      <p class="bookDescription body article font2">
        <p>“[My life] is so rich with blessings—an immense capacity of enjoyment, books, and beloved friends. . . . Most earnestly I pray the dear Heavenly Father that I may sometime make myself far more worthy of the love shown to me than I am now.”<br/>—April 22, 1900 letter from Helen Keller to John Hitz, AFB<br/>When Helen Keller died in 1968, at the age of eighty-eight years old, she was one of the most widely known women in the world. The overnight success of her biography, The Story of My Life, written at age twenty-three, made it obvious to Keller that she was endowed with a gift for writing and speaking. As she got older, she increasingly began to do both on a variety of subjects extending beyond her own disability, including social, political, and theological issues.<br/>Helen Keller: Selected Writings collects Keller’s personal letters, political writings, speeches, and excerpts of her published materials from 1887 to 1968. The book also includes an introductory essay by Kim E. Nielsen, headnotes to each document, and a selected bibliography of work by and about Keller. The majority of the letters and some prints, all drawn from the Helen Keller Archives at the American Foundation for the Blind in New York, are being published for the first time.<br/>Literature, education, advocacy, politics, religion, travel: the many interests of Helen Keller culminate in this book and are reflected in her spirited narration. Also portrayed are the individuals Keller inspired and took inspiration from, including her teacher Annie Sullivan, her family, and others with whom she formed friendships throughout the course of her life.<br/>This often charming collection revels in and preserves Keller’s public and private life, coming to us in the year which marks the 125th anniversary of her birthday.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kim E Nielsen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e8ad62a